import { connect } from 'react-redux'

import * as casino from '@rushplay/casino'

import { LiveCasinoNavigation as Component } from './live-casino-navigation'

export const LiveCasinoNavigation = connect(null, dispatch => ({
  onUpdateCategory: gameType =>
    dispatch(casino.actions.updateFilterGameType(gameType)),
}))(Component)
